import React from 'react';
import { Link } from 'react-router-dom';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Separator } from './ui/separator';
import { Trophy, Mail, Globe } from 'lucide-react';

export const Footer = () => {
  const exploreLinks = [
    { name: 'Home', path: '/' },
    { name: 'Categories', path: '/categories' },
    { name: 'Jury', path: '/jury' },
    { name: 'About', path: '/about' }
  ];

  const handleSubscribe = (e) => {
    e.preventDefault();
    const toast = document.createElement('div');
    toast.textContent = 'Thanks for subscribing! We\'ll keep you updated.';
    toast.className = 'fixed top-4 right-4 bg-amber-500 text-white px-6 py-3 rounded-lg shadow-lg z-50';
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  };

  return (
    <footer className="bg-black text-white" data-testid="site-footer">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* About Column */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="h-10 w-10 rounded-lg bg-amber-500 flex items-center justify-center">
                <Trophy className="h-6 w-6 text-white" />
              </div>
              <div className="flex flex-col leading-tight">
                <span className="font-bold text-lg">Stand Vision Awards</span>
                <span className="text-xs text-amber-400">Excellence in Exhibition Design</span>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-sm">
              The world's most prestigious exhibition stand design competition. Celebrating creativity, innovation, and excellence in trade show design.
            </p>
          </div>

          {/* Explore Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Explore</h3>
            <ul className="space-y-3">
              {exploreLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors inline-flex items-center gap-2"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <div className="space-y-3 mb-6">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Globe className="h-4 w-4 text-amber-400" />
                <span>www.standvisionawards.com</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Mail className="h-4 w-4 text-amber-400" />
                <span>info@standvisionawards.com</span>
              </div>
            </div>

            {/* Newsletter */}
            <form onSubmit={handleSubscribe} className="space-y-2">
              <Input
                type="email"
                placeholder="Enter your email"
                className="bg-white/10 border-white/20 text-white placeholder:text-gray-500 focus:border-amber-400 h-10"
                data-testid="subscribe-input"
                required
              />
              <Button
                type="submit"
                className="w-full bg-amber-500 hover:bg-amber-600 text-white h-10 font-medium"
                data-testid="subscribe-button"
              >
                Subscribe
              </Button>
            </form>
          </div>
        </div>
      </div>

      <Separator className="bg-white/10" />

      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>© 2024 Stand Vision Awards. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};